import { StyleSheet } from 'react-native';

export const stadiumBackdropStyles = StyleSheet.create({
  root: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  scene: {
    ...StyleSheet.absoluteFillObject,
  },
  beamLeft: {
    position: 'absolute',
    top: -40,
    left: 6,
    width: 200,
    height: 320,
  },
  beamRight: {
    position: 'absolute',
    top: -40,
    right: 6,
    width: 200,
    height: 320,
  },
  groundShadow: {
    position: 'absolute',
    bottom: 26,
    alignSelf: 'center',
    left: '50%',
    width: 160,
    height: 22,
    marginLeft: -80,
    borderRadius: 9999,
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
});
